import { observable, action } from 'mobx';

class ShippingUIState {
  @observable continueButtonIsEnabled = true;

  @observable continueButtonIsLoading = false;

  @observable addressSelectionIsEnabled = true;

  @observable isShippingMethodsMissing = false;

  @action
  public updateContinueButtonState(isEnabled: boolean): void {
    this.continueButtonIsEnabled = isEnabled;
  }

  @action
  public updateContinueLoadingButtonState(isLoading: boolean): void {
    this.continueButtonIsLoading = isLoading;
    this.continueButtonIsEnabled = !isLoading;
  }

  @action
  public updateAddressSelectionState(isEnabled: boolean): void {
    this.addressSelectionIsEnabled = isEnabled;
  }

  @action
  public updateisShippingMethodsMissing(isFailed: boolean): void {
    this.isShippingMethodsMissing = isFailed;
    if (isFailed) {
      this.continueButtonIsEnabled = false;
      this.continueButtonIsLoading = false;
      this.addressSelectionIsEnabled = false;
    }
  }

  @action
  public restoreDefaults(): void {
    this.continueButtonIsEnabled = true;
    this.continueButtonIsLoading = false;
    this.addressSelectionIsEnabled = true;
    this.isShippingMethodsMissing = false;
  }
}

export default ShippingUIState;
